interface Bar { label: string; value: number }
export function SvgBarChart({ data }: { data: Bar[] }) {
  if (!data.length) return <p className="text-sm text-gray-500">Sin datos</p>;
  
  const max = Math.max(...data.map((d) => d.value), 1);
  const rowHeight = 36;
  const labelWidth = 160; // Space for labels
  const barMaxWidth = 260;
  const paddingRight = 40;
  const width = labelWidth + barMaxWidth + paddingRight;
  const height = data.length * rowHeight;

  return (
    <div className="overflow-x-auto w-full border border-gray-100 dark:border-neutral-700 rounded-2xl bg-white dark:bg-neutral-800 p-4 shadow-sm">
      <svg role="img" aria-label="Barras" viewBox={`0 0 ${width} ${height}`} className="w-full font-sans" style={{ height: `${height}px`, maxHeight: '80vh' }}>
        {data.map((d, i) => {
          const barWidth = (d.value / max) * barMaxWidth;
          const y = i * rowHeight;
          return (
            <g key={i}>
              {/* Product/Category Label */}
              <text 
                x={labelWidth - 12} 
                y={y + rowHeight / 2 + 4} 
                textAnchor="end" 
                fontSize={11} 
                fill="currentColor"
                className="text-gray-700 dark:text-gray-300 font-medium"
              >
                {d.label.length > 22 ? d.label.slice(0, 20) + '..' : d.label}
                <title>{d.label}</title>
              </text>
              
              {/* Bar */}
              <rect 
                x={labelWidth} 
                y={y + 8} 
                width={Math.max(barWidth, 4)} 
                height={rowHeight - 16} 
                rx={4}
                fill="#10b981"
                className="transition-all duration-300 hover:fill-emerald-600"
              >
                <title>{`${d.label}: ${d.value}`}</title>
              </rect>
              
              {/* Value Label */}
              <text 
                x={labelWidth + barWidth + 8} 
                y={y + rowHeight / 2 + 4} 
                fontSize={11} 
                fill="currentColor"
                className="text-gray-500 dark:text-gray-400 font-semibold"
              >
                {d.value}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}
